export default {
  pending: "Pendente",
  paid: "Paga",
  canceled: "Cancelada",
  partially_paid: "Parcialmente Paga",
  refunded: "Reembolsada",
  expired: "Vencida",
  authorized: "Autorizada"
};



// WEBPACK FOOTER //
// ./src/core/enum/billing-status.enum.js